<template>
  <div>
    <div class="container">
      <p class="title">在线报名</p>
      <p class="little_title">e代驾司机招募</p>
      <div class="auth_code">
        <input placeholder="请输入手机号" v-model="phone" maxlength="11" />
        <input placeholder="请输入验证码" v-model="code" @input="watchVal($event)" />
        <button :disabled="disabled" @click="sendCode">{{ btnTxt }}</button>
      </div>
      <p class="status" v-show="disabled">验证码已发送，可能会有延后，请耐心等待</p>
    </div>
    <button class="submit" @click="submit">注册/登录</button>
    <div class="agreement">
      <img :src="isAgree ? icon_yes : icon_no" @click="changeAgree" />
      <span>我已阅读并同意</span>
      <a :href="drivingAgreement">《使用规则与代驾服务协议》、</a>
      <a :href="msgAgreement">《信息服务协议》</a>
    </div>
    <div class="tips">
      {{ defaultInfo.default_text }}<span>{{ defaultInfo.default }}</span>
    </div>
  </div>
</template>

<script>
import { showToast, changeHistory } from '../../utils/common.js'
import { createVerifycode, checkVerifycode, checkStatus, getCompanyInfo } from '../../utils/actions'
export default {
  data () {
    return {
      drivingAgreement: location.origin + '/driver-app-pack/driver-study/page/10/10_1.html',
      msgAgreement: location.origin + '/driver-app-pack/driver-study/page/10/10_2.html',
      phone: '',
      code: '',
      btnTxt: '获取验证码',
      time: 0,
      disabled: false,
      icon_yes: require('../../assets/choose_yes.png'),
      icon_no: require('../../assets/choose_no.png'),
      isAgree: true,
      defaultInfo: {
        default: '95139',
        default_text: '司机加盟咨询热线：'
      }
    }
  },
  created () {
    changeHistory()
    getCompanyInfo({
      city_id: this.$store.state.cityId || '0'
    }).then((res) => {
      this.defaultInfo = res.data
    })
  },
  methods: {
    watchVal (e) {
      let val = e.target.value
      this.code = val.substring(0, 6)
    },
    sendCode () {
      if (!this.checkCode()) return
      this.createVerifycode()
    },

    checkCode () {
      let reg = 11 && /^1\d{10}$/
      if (this.phone == '') {//eslint-disable-line
        showToast('请输入手机号码')
      } else if (!reg.test(this.phone)) {
        showToast('手机格式不正确')
      } else {
        return this.phone
      }
    },

    async createVerifycode () {
      let _this = this
      let data = await createVerifycode({
        open_id: _this.$store.state.openid,
        mobile: _this.phone,
        business: 'driverSignup'
      })
      if (data && data.code == 0) {//eslint-disable-line
        _this.disabled = true
        _this.time = 60
        _this.timer()
      }
    },

    timer () {
      if (this.time > 0) {
        this.time--
        this.btnTxt = this.time + 's后重新获取'
        setTimeout(this.timer, 1000)
      } else {
        this.disabled = false
        this.time = 0
        this.btnTxt = '获取验证码'
      }
    },

    changeAgree () {
      this.isAgree = !this.isAgree
    },

    submit () {
      if (!this.isAgree) {
        showToast('请您阅读并同意代驾服务协议')
        return
      }
      if (!this.checkCode()) return
      if (!this.code || this.code.length > 6) {
        showToast('请输入正确验证码')
        return
      }
      this.checkVerifycode()
    },

    async checkVerifycode () {
      let data = await checkVerifycode({
        open_id: this.$store.state.openid,
        mobile: this.phone,
        verifyCode: this.code,
        business: 'driverSignup',
        agree: '1'// 同意代驾服务协议
      })
      if (data) {
        this.$store.commit('TOKEN', data.data.zm_token || '') // token
        this.checkStatus()
      }
    },
    async checkStatus () {
      let data = await checkStatus({
        open_id: this.$store.state.openid
      })
      if (!data) return
      if (data.data.recycle == '1') {//eslint-disable-line
        this.$router.push({ name: 'defeat' })
        return
      }
      this.$store.commit('ID', data.data.id) // id
      this.$store.commit('CITYID', data.data.city_id) // cityId
      this.$store.commit('IDCAR', data.data.id_card) // cardId
      this.$store.commit('PHONE', data.data.mobile) // phone
      this.$store.commit('CNAME', data.data.company_name) // 路考分公司
      this.$store.commit('CPHONE', data.data.company_phone) // 分公司电话
      switch (data.data.status) { // 待完善
        case '1': // 流程第1步报名
          // 报名页面1
          this.$router.push({ name: 'signUp', params: { status: data.data.status } })
          break
        case '2': // 报名成功,
        case '3': // 考试未通过
        case '4': // 考试通过
          // 答题页 2
          this.$router.push({ name: 'recruitAnswer', params: { status: data.data.status } })
          break
        case '5': // 身份证证件未通过
          // 身份证拍照页面
          this.$router.push({ name: 'cardIDUpLoad', params: { status: data.data.status } })
          break
        case '6': // 身份证证件通过
        case '7': // 驾驶证未通过
          // 驾驶证拍照页面
          this.$router.push({ name: 'licenceLoad', params: { status: data.data.status } })
          break
        case '8': // 驾照验证通过
        case '9': // 面试未邀请
        case '10': // 面试已邀请
        case '11': // 面试未通过
          // 信息审核 5
          this.$router.push({ name: 'msgAudit', params: { status: data.data.status } })
          break
        case '12': // 面试通过
        case '13': // 路考未预约
          // 预约路考页面 6
          this.$router.push({ name: 'appointedRoadTest', params: { status: data.data.status } })
          break
        case '14': // 路考已预约-报名完成
        case '15': // 路考进行中
        case '16': // 路考不通过
        case '17': // 路考通过
        case '18': // 成功签约
        case '19': // 已领装备
          this.$router.push({ name: 'passStatus', params: { status: data.data.status } })
          break
        default:
          break
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.container {
  width: 80%;
  margin-left: 10%;

  .title {
    font-size: .4rem;
    color: #19191A;
    font-weight: bold;
    margin-top: .8rem;
  }

  .little_title {
    font-size: .24rem;
    color: #19191A;
    margin-bottom: .08rem;
  }

  input {
    width: 100%;
    border: none;
    height: .98rem;
    line-height: .98rem;
    font-size: .28rem;
    border-bottom: 1px solid #E8E9EB;
    vertical-align: bottom;
    border-radius: 0;
    background: #FCFDFF;
    padding: 0
  }

  .status {
    font-size: .24rem;
    color: #19191A;
    margin: .14rem 0 .32rem 0;
    text-align: center;
  }
}

.auth_code {
  position: relative;

  button {
    font-size: .28rem;
    position: absolute;
    right: 0;
    height: .98rem;
    line-height: .98rem;
    display: inline-block;
    bottom: .02rem;
    border: none;
    padding: 0;
    background: #FCFDFF;
    outline: none;
  }
}

.agreement {
  width: 80%;
  font-size: .24rem;
  margin: .26rem 0 .4rem 10%;

  img {
    width: .24rem;
    height: auto;
    vertical-align: middle;
    padding-bottom: .1rem;
    margin-right: .1rem;
  }

  a {
    color: #4AA8EC;
    height: .4rem;
    line-height: .4rem;
    display: inline-block;
  }

  span {
    height: .4rem;
    line-height: .4rem;
    display: inline-block;
  }
}

.tips {
  width: 100%;
  position: fixed;
  bottom: 0;
  text-align: center;
  font-size: .24rem;
  font-weight: 400;
  color: #19191A;
  line-height: .34rem;
  margin: .98rem auto .8rem;

  span {
    color: #2A2AFF;
  }
}

.submit {
  margin-left: 7%;
  width: 86%;
  margin-top: .8rem;
  background-image: linear-gradient(269deg, #3B414D 0%, #262A32 100%);
  border-radius: .04rem;
  color: #fff;
  height: .92rem;
  line-height: .92rem;
  font-size: .3rem;
  padding: 0;
  border: none;
  outline: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/login/index.vue